<script setup lang="ts">
const emits = defineEmits(['fullscreen'])
</script>

<template>
  <button
    class="opacity-90 bg-brand-white text-brand-secondary-400 rounded-r font-bold flex items-center justify-center w-9 h-9"
    @click="emits('fullscreen')"
  >
    <Icon name="material-symbols:fullscreen" size="30" />
  </button>
</template>
